'use strict';

export default {
    findUsList: {},
    blogPosts: {},
    jobsList: {},
    form: {}
}